import { createContext, FC, useState } from "react";
import { Auth, AuthContextType } from "./auth.types";

export const AuthContext = createContext<AuthContextType>({} as AuthContextType)

export const AuthProvider: FC = ({ children }) => {
    const auth = useAuthProvider()
    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

const useAuthProvider = (): AuthContextType => {
    const [auth, setAuth] = useState<Auth>({ loading: true, isAuthenticated: false });
    return {
        auth,
        setAuth
    }
}